import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types';
export type CustomizedSummaryDetailsProps = CommonProps & {
  variant: 'customizedSummary';
  CollapseDetailsComponent: ReactNode;
  collapseDetailsParentProps?: Partial<BoxProps> & {
    ['data-testid']?: string;
  };
  ExpandDetailsComponent: ReactNode;
  expandDetailsParentProps?: Partial<BoxProps> & {
    ['data-testid']?: string;
  };
};
export function CustomizedSummaryDetails(t0) {
  const $ = _c(42);
  const {
    children,
    CollapseDetailsComponent,
    collapseDetailsParentProps: t1,
    detailsProps: t2,
    ExpandDetailsComponent,
    expandDetailsParentProps,
    summaryComponentProps: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const collapseDetailsParentProps = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const detailsProps = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const summaryComponentProps = t6;
  let restDetailsProps;
  let sxDetailsProps;
  if ($[6] !== detailsProps) {
    ({
      sx: sxDetailsProps,
      ...restDetailsProps
    } = detailsProps);
    $[6] = detailsProps;
    $[7] = restDetailsProps;
    $[8] = sxDetailsProps;
  } else {
    restDetailsProps = $[7];
    sxDetailsProps = $[8];
  }
  let restCollapseDetailsParentProps;
  let sxCollapseDetailsParentProps;
  if ($[9] !== collapseDetailsParentProps) {
    ({
      sx: sxCollapseDetailsParentProps,
      ...restCollapseDetailsParentProps
    } = collapseDetailsParentProps);
    $[9] = collapseDetailsParentProps;
    $[10] = restCollapseDetailsParentProps;
    $[11] = sxCollapseDetailsParentProps;
  } else {
    restCollapseDetailsParentProps = $[10];
    sxCollapseDetailsParentProps = $[11];
  }
  let restSummaryComponentProps;
  let sxSummaryComponentProps;
  if ($[12] !== summaryComponentProps) {
    ({
      sx: sxSummaryComponentProps,
      ...restSummaryComponentProps
    } = summaryComponentProps);
    $[12] = summaryComponentProps;
    $[13] = restSummaryComponentProps;
    $[14] = sxSummaryComponentProps;
  } else {
    restSummaryComponentProps = $[13];
    sxSummaryComponentProps = $[14];
  }
  let t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "none"
    };
    t8 = {
      display: "flex"
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[17] !== sxDetailsProps) {
    t9 = {
      position: "relative",
      "&[open] > summary > .open-summary": t7,
      "&[open] > summary > .close-summary": t8,
      ...sxDetailsProps
    };
    $[17] = sxDetailsProps;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "none"
    };
    t11 = {
      display: "none"
    };
    $[19] = t10;
    $[20] = t11;
  } else {
    t10 = $[19];
    t11 = $[20];
  }
  let t12;
  if ($[21] !== sxSummaryComponentProps) {
    t12 = {
      listStyle: "none",
      listStyleType: "none",
      "::-webkit-details-marker": t10,
      "::marker": t11,
      cursor: "pointer",
      ...sxSummaryComponentProps
    };
    $[21] = sxSummaryComponentProps;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== ExpandDetailsComponent || $[24] !== expandDetailsParentProps) {
    t13 = <Box component="span" className="open-summary" {...expandDetailsParentProps}>{ExpandDetailsComponent}</Box>;
    $[23] = ExpandDetailsComponent;
    $[24] = expandDetailsParentProps;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== sxCollapseDetailsParentProps) {
    t14 = {
      display: "none",
      ...sxCollapseDetailsParentProps
    };
    $[26] = sxCollapseDetailsParentProps;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== CollapseDetailsComponent || $[29] !== restCollapseDetailsParentProps || $[30] !== t14) {
    t15 = <Box component="span" className="close-summary" sx={t14} {...restCollapseDetailsParentProps}>{CollapseDetailsComponent}</Box>;
    $[28] = CollapseDetailsComponent;
    $[29] = restCollapseDetailsParentProps;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== restSummaryComponentProps || $[33] !== t12 || $[34] !== t13 || $[35] !== t15) {
    t16 = <Box component="summary" data-testid="detail-summary" sx={t12} {...restSummaryComponentProps}>{t13}{t15}</Box>;
    $[32] = restSummaryComponentProps;
    $[33] = t12;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== children || $[38] !== restDetailsProps || $[39] !== t16 || $[40] !== t9) {
    t17 = <Box sx={t9} component="details" {...restDetailsProps}>{t16}{children}</Box>;
    $[37] = children;
    $[38] = restDetailsProps;
    $[39] = t16;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
}